"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetMetricFormatEnum = void 0;
var StatsWidgetMetricFormatEnum;
(function (StatsWidgetMetricFormatEnum) {
    StatsWidgetMetricFormatEnum["STATIC"] = "STATIC";
    StatsWidgetMetricFormatEnum["VALUE_PCS"] = "ValuePCS";
    StatsWidgetMetricFormatEnum["VALUE_PERCENT"] = "ValuePercent";
    StatsWidgetMetricFormatEnum["VALUE_DECIMAL"] = "ValueDecimal";
    StatsWidgetMetricFormatEnum["SECONDS_TO_HH_MM"] = "SECONDS_TO_HH_MM";
    StatsWidgetMetricFormatEnum["SECONDS_TO_HH_MM_SS"] = "SECONDS_TO_HH_MM_SS";
    StatsWidgetMetricFormatEnum["SECONDS_TO_MM_SS"] = "SECONDS_TO_MM_SS";
    StatsWidgetMetricFormatEnum["YEAR_MONTH_SHORT"] = "YEAR_MONTH_SHORT";
    StatsWidgetMetricFormatEnum["YEAR_MONTH_LONG"] = "YEAR_MONTH_LONG";
    StatsWidgetMetricFormatEnum["MONTH_SHORT"] = "MONTH_SHORT";
    StatsWidgetMetricFormatEnum["MONTH_LONG"] = "MONTH_LONG";
    StatsWidgetMetricFormatEnum["YEAR_WEEK_NUMBER"] = "YEAR_WEEK_NUMBER";
    StatsWidgetMetricFormatEnum["WEEK_NUMBER"] = "WEEK_NUMBER";
    StatsWidgetMetricFormatEnum["HH_mm"] = "HH_mm";
    StatsWidgetMetricFormatEnum["HH_mm_ss"] = "HH_mm_ss";
    StatsWidgetMetricFormatEnum["mm_ss"] = "mm_ss";
    StatsWidgetMetricFormatEnum["D_SLASH_M"] = "D_SLASH_M";
    StatsWidgetMetricFormatEnum["YYYYMMDD"] = "YYYYMMDD";
    StatsWidgetMetricFormatEnum["YYYY_MM_DD"] = "YYYY_MM_DD";
    StatsWidgetMetricFormatEnum["YYYY_MM_DD_HH_mm"] = "YYYY_MM_DD_HH_mm";
    StatsWidgetMetricFormatEnum["YYYY_MM_DD_HH_mm_ss"] = "YYYY_MM_DD_HH_mm_ss";
    StatsWidgetMetricFormatEnum["D_SLASH_M_HH_mm"] = "D_SLASH_M_HH_mm";
    StatsWidgetMetricFormatEnum["HOUR_OF_DAY_24H"] = "HOUR_OF_DAY_24H";
    StatsWidgetMetricFormatEnum["HOUR_OF_DAY_12H"] = "HOUR_OF_DAY_12H";
    StatsWidgetMetricFormatEnum["WEEKDAY_SHORT"] = "WEEKDAY_SHORT";
    StatsWidgetMetricFormatEnum["WEEKDAY_LONG"] = "WEEKDAY_LONG";
    StatsWidgetMetricFormatEnum["COUNTDOWN"] = "COUNTDOWN";
})(StatsWidgetMetricFormatEnum = exports.StatsWidgetMetricFormatEnum || (exports.StatsWidgetMetricFormatEnum = {}));
